import { useCallback, useState } from 'react';
import { shareApi } from '../services/shareApi';
import { SHARE_USE_STUB as USE_STUB } from '../config';

// Creates (or returns the existing canonical) share link for a course the
// caller owns. Used by ShareModal when a creator clicks "Share".
export function useCreateShare() {
  const [status, setStatus] = useState('idle'); // idle | loading | ready | error
  const [share, setShare] = useState(null);
  const [error, setError] = useState(null);

  const create = useCallback(async (courseId, { authEnabled = true } = {}) => {
    setStatus('loading');
    setError(null);
    try {
      if (USE_STUB) {
        await new Promise((r) => setTimeout(r, 400));
        const token = 'demo';
        const res = {
          shareId: 'stub-share',
          token,
          url: `${window.location.origin}/shared/${token}`,
          acceptCount: 3,
        };
        setShare(res);
        setStatus('ready');
        return res;
      }
      const res = await shareApi.createShare({ courseId, auth: authEnabled });
      setShare(res);
      setStatus('ready');
      return res;
    } catch (e) {
      setError(e);
      setStatus('error');
      return null;
    }
  }, []);

  return { create, status, share, error };
}
